module.exports = __webpack_public_path__ + "img/趋势解读，直达爆款ico.e3112958.png";